// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/server/v1/support.proto (package chalk.server.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_chalk_auth_v1_audit } from "../../auth/v1/audit_pb";
import { file_chalk_auth_v1_permissions } from "../../auth/v1/permissions_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/server/v1/support.proto.
 */
export const file_chalk_server_v1_support: GenFile = /*@__PURE__*/
  fileDesc("Ch1jaGFsay9zZXJ2ZXIvdjEvc3VwcG9ydC5wcm90bxIPY2hhbGsuc2VydmVyLnYxIjQKGEluY2lkZW50U2VydmljZVJlZmVyZW5jZRIKCgJpZBgBIAEoCRIMCgR0eXBlGAIgASgJIi0KDEluY2lkZW50Qm9keRIMCgR0eXBlGAEgASgJEg8KB2RldGFpbHMYAiABKAki7AEKCEluY2lkZW50EgwKBHR5cGUYASABKAkSDQoFdGl0bGUYAiABKAkSOgoHc2VydmljZRgDIAEoCzIpLmNoYWxrLnNlcnZlci52MS5JbmNpZGVudFNlcnZpY2VSZWZlcmVuY2USFAoHdXJnZW5jeRgEIAEoCUgAiAEBEhkKDGluY2lkZW50X2tleRgFIAEoCUgBiAEBEjAKBGJvZHkYBiABKAsyHS5jaGFsay5zZXJ2ZXIudjEuSW5jaWRlbnRCb2R5SAKIAQFCCgoIX3VyZ2VuY3lCDwoNX2luY2lkZW50X2tleUIHCgVfYm9keSJMCh1DcmVhdGVDdXN0b21lckluY2lkZW50UmVxdWVzdBIrCghpbmNpZGVudBgBIAEoCzIZLmNoYWxrLnNlcnZlci52MS5JbmNpZGVudCIgCh5DcmVhdGVDdXN0b21lckluY2lkZW50UmVzcG9uc2Uy1gEKDlN1cHBvcnRTZXJ2aWNlEsMBChZDcmVhdGVDdXN0b21lckluY2lkZW50Ei4uY2hhbGsuc2VydmVyLnYxLkNyZWF0ZUN1c3RvbWVySW5jaWRlbnRSZXF1ZXN0Gi8uY2hhbGsuc2VydmVyLnYxLkNyZWF0ZUN1c3RvbWVySW5jaWRlbnRSZXNwb25zZSJIgH0FitMOQQgCEj1DcmVhdGVkIGEgY3VzdG9tZXIgaW5jaWRlbnQgaW4gdGhlIGluY2lkZW50IG1hbmFnZW1lbnQgc3lzdGVtQhRaEnNlcnZlci92MTtzZXJ2ZXJ2MWIGcHJvdG8z", [file_chalk_auth_v1_audit, file_chalk_auth_v1_permissions]);

/**
 * @generated from message chalk.server.v1.IncidentServiceReference
 */
export type IncidentServiceReference = Message<"chalk.server.v1.IncidentServiceReference"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string type = 2;
   */
  type: string;
};

/**
 * Describes the message chalk.server.v1.IncidentServiceReference.
 * Use `create(IncidentServiceReferenceSchema)` to create a new message.
 */
export const IncidentServiceReferenceSchema: GenMessage<IncidentServiceReference> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_support, 0);

/**
 * @generated from message chalk.server.v1.IncidentBody
 */
export type IncidentBody = Message<"chalk.server.v1.IncidentBody"> & {
  /**
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: string details = 2;
   */
  details: string;
};

/**
 * Describes the message chalk.server.v1.IncidentBody.
 * Use `create(IncidentBodySchema)` to create a new message.
 */
export const IncidentBodySchema: GenMessage<IncidentBody> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_support, 1);

/**
 * @generated from message chalk.server.v1.Incident
 */
export type Incident = Message<"chalk.server.v1.Incident"> & {
  /**
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: chalk.server.v1.IncidentServiceReference service = 3;
   */
  service?: IncidentServiceReference;

  /**
   * @generated from field: optional string urgency = 4;
   */
  urgency?: string;

  /**
   * @generated from field: optional string incident_key = 5;
   */
  incidentKey?: string;

  /**
   * @generated from field: optional chalk.server.v1.IncidentBody body = 6;
   */
  body?: IncidentBody;
};

/**
 * Describes the message chalk.server.v1.Incident.
 * Use `create(IncidentSchema)` to create a new message.
 */
export const IncidentSchema: GenMessage<Incident> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_support, 2);

/**
 * @generated from message chalk.server.v1.CreateCustomerIncidentRequest
 */
export type CreateCustomerIncidentRequest = Message<"chalk.server.v1.CreateCustomerIncidentRequest"> & {
  /**
   * @generated from field: chalk.server.v1.Incident incident = 1;
   */
  incident?: Incident;
};

/**
 * Describes the message chalk.server.v1.CreateCustomerIncidentRequest.
 * Use `create(CreateCustomerIncidentRequestSchema)` to create a new message.
 */
export const CreateCustomerIncidentRequestSchema: GenMessage<CreateCustomerIncidentRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_support, 3);

/**
 * @generated from message chalk.server.v1.CreateCustomerIncidentResponse
 */
export type CreateCustomerIncidentResponse = Message<"chalk.server.v1.CreateCustomerIncidentResponse"> & {
};

/**
 * Describes the message chalk.server.v1.CreateCustomerIncidentResponse.
 * Use `create(CreateCustomerIncidentResponseSchema)` to create a new message.
 */
export const CreateCustomerIncidentResponseSchema: GenMessage<CreateCustomerIncidentResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_support, 4);

/**
 * @generated from service chalk.server.v1.SupportService
 */
export const SupportService: GenService<{
  /**
   * @generated from rpc chalk.server.v1.SupportService.CreateCustomerIncident
   */
  createCustomerIncident: {
    methodKind: "unary";
    input: typeof CreateCustomerIncidentRequestSchema;
    output: typeof CreateCustomerIncidentResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_chalk_server_v1_support, 0);

